import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faChevronRight,
  faBuilding,
  faClock,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import logoSmall from "../../assets/images/logo-2.svg";

const Footer = () => {
  const [activeLocation, setActiveLocation] = useState("jaipur");
  const [hoveredNav, setHoveredNav] = useState(null);
  const [hoveredSocial, setHoveredSocial] = useState(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleLocationChange = (location) => {
    setActiveLocation(location);
  };

  return (
    <footer>
      {/* Slanted top border */}
      <div className="footer-slant"></div>

      {/* Main footer content */}
      <div className="footer-main">
        <div className="footer-grid">
          {/* Logo and company description */}
          <div className="footer-block company-block">
            <div className="company-logo">
              <img 
                src={logoSmall} 
                alt="DEE CEE Elevators" 
                className="logo-image"
              />
            </div>
            <p className="company-description">
              Delivering innovative design, superior craftsmanship, and
              unparalleled customer service in vertical transportation solutions
              since 2007.
            </p>
            <div className="company-stats">
              <div className="stat-item">
                <span className="stat-number">13+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">500+</span>
                <span className="stat-label">Projects Completed</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Support Available</span>
              </div>
            </div>
          </div>

          {/* Combined Navigation and Services */}
          <div className="footer-block">
            <h3 className="block-title">Quick Links</h3>
            <div className="nav-columns">
              <ul className="footer-nav">
                <li>
                  <Link
                    to="/"
                    className={hoveredNav === "home" ? "active" : ""}
                    onMouseEnter={() => setHoveredNav("home")}
                    onMouseLeave={() => setHoveredNav(null)}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className={hoveredNav === "about" ? "active" : ""}
                    onMouseEnter={() => setHoveredNav("about")}
                    onMouseLeave={() => setHoveredNav(null)}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/products"
                    className={hoveredNav === "products" ? "active" : ""}
                    onMouseEnter={() => setHoveredNav("products")}
                    onMouseLeave={() => setHoveredNav(null)}
                  >
                    Products
                  </Link>
                </li>
                <li>
                  <Link
                    to="/gallery"
                    className={hoveredNav === "gallery" ? "active" : ""}
                    onMouseEnter={() => setHoveredNav("gallery")}
                    onMouseLeave={() => setHoveredNav(null)}
                  >
                    Gallery
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className={hoveredNav === "contact" ? "active" : ""}
                    onMouseEnter={() => setHoveredNav("contact")}
                    onMouseLeave={() => setHoveredNav(null)}
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <a
                    href="https://deeceeelevators.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={hoveredNav === "oldsite" ? "active" : ""}
                    onMouseEnter={() => setHoveredNav("oldsite")}
                    onMouseLeave={() => setHoveredNav(null)}
                  >
                    Old Website
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact us and Business Hours - combined */}
          <div className="footer-block contact-block">
            <h3 className="block-title">Contact Us</h3>
            <div className="location-info">
              <div className="info-item">
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="info-icon"
                />
                <span>
                  342, Vardhman Nagar <br /> Badarwas, Ajmer Road,
                  <br /> Jaipur- 302019
                </span>
              </div>
              <div className="info-item">
                <FontAwesomeIcon icon={faPhone} className="info-icon" />
                <span>+91-9887-772727</span>
              </div>
              <div className="info-item">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="info-icon"
                />
                <span>info@deeceeelevators.com</span>
              </div>
              <div className="info-item">
                <FontAwesomeIcon icon={faClock} className="info-icon" />
                <span>24/7 Emergency Support</span>
              </div>
            </div>
            
            <div className="business-hours-inline">
              <h4 className="hours-title">Business Hours</h4>
              <div className="hours-compact">
                <span className="hours-item-compact">
                  <strong>Mon - Sat:</strong> 10:00 AM - 6:00 PM
                </span>
                <span className="hours-item-compact">
                  <strong>Sunday:</strong> Closed
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Social media and call to action - with social-specific state variable */}
        <div className="footer-social">
          <div className="social-connect">
            <h3>Connect With Us</h3>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/deeceelevators/"
                className={hoveredSocial === "fb" ? "active" : ""}
                onMouseEnter={() => setHoveredSocial("fb")}
                onMouseLeave={() => setHoveredSocial(null)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://www.instagram.com/deeceeelevators/"
                className={hoveredSocial === "ig" ? "active" : ""}
                onMouseEnter={() => setHoveredSocial("ig")}
                onMouseLeave={() => setHoveredSocial(null)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://linkedin.com"
                className={hoveredSocial === "li" ? "active" : ""}
                onMouseEnter={() => setHoveredSocial("li")}
                onMouseLeave={() => setHoveredSocial(null)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a
                href="https://wa.me/9887772727"
                className={hoveredSocial === "wa" ? "active" : ""}
                onMouseEnter={() => setHoveredSocial("wa")}
                onMouseLeave={() => setHoveredSocial(null)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </div>
          </div>
          <div className="cta-button">
            <Link to="/contact">Contact us</Link>
          </div>
        </div>
      </div>

      {/* Copyright section */}
      <div className="copyright">
        <div className="copyright-content">
          <p>
            © {new Date().getFullYear()} DEE CEE Elevators Pvt Ltd. All rights reserved.
          </p>
          <div className="legal-links">
            <span>Privacy Policy</span>
            <span>•</span>
            <span>Terms of Service</span>
            <span>•</span>
            <span>Warranty</span>
          </div>
        </div>
        <button
          onClick={scrollToTop}
          className="scroll-top"
          aria-label="Scroll to top"
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
      </div>

      <style jsx>{`
        footer {
          position: relative;
          font-family: "Poppins", "Segoe UI", sans-serif;
          color: #ffffff;
        }

        .footer-slant {
          height: 40px;
          background-color: #0b1f38;
          clip-path: polygon(0 30%, 100% 0, 100% 100%, 0% 100%);
          margin-bottom: -20px;
        }

        .footer-main {
          background-color: #0b1f38;
          padding: 30px 20px 50px;
          position: relative;
          overflow: hidden;
        }

        .footer-main::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 300px;
          height: 300px;
          background: radial-gradient(
            circle,
            rgba(56, 128, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 70%
          );
          border-radius: 50%;
          transform: translate(100px, -150px);
          z-index: 0;
        }

        .footer-grid {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr;
          gap: 50px;
          position: relative;
          z-index: 1;
        }

        .footer-block {
          display: flex;
          flex-direction: column;
        }

        .company-logo {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .logo-image {
          height: 160px;
          width: 230px;
          margin-bottom: 8px;
          border: 2px solid rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          padding: 15px;
          background: rgba(255, 255, 255, 0.02);
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .logo-image:hover {
          border-color: rgba(56, 128, 255, 0.3);
          background: rgba(56, 128, 255, 0.05);
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(56, 128, 255, 0.15);
        }

        .tagline {
          font-size: 13px;
          letter-spacing: 1.2px;
          color: #3880ff;
          margin-top: 2px;
          position: relative;
        }

        .company-description {
          margin-top: 20px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 1.7;
          max-width: 90%;
        }

        .company-stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          margin-top: 25px;
          padding-top: 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .stat-item {
          text-align: center;
          padding: 15px 8px;
          background: rgba(255, 255, 255, 0.02);
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          transition: all 0.3s ease;
        }

        .stat-item:hover {
          background: rgba(56, 128, 255, 0.1);
          border-color: rgba(56, 128, 255, 0.2);
          transform: translateY(-2px);
        }

        .stat-number {
          display: block;
          font-size: 1.8rem;
          font-weight: 700;
          color: #3880ff;
          margin-bottom: 5px;
        }

        .stat-label {
          display: block;
          font-size: 0.75rem;
          color: rgba(255, 255, 255, 0.6);
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .nav-columns {
          display: flex;
          gap: 30px;
        }

        .nav-columns .footer-nav {
          flex: 1;
          min-width: 0;
        }

        .services-nav {
          margin-top: 0;
        }

        .nav-subtitle {
          font-weight: 600;
          color: #3880ff;
          font-size: 14px;
          margin-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .business-hours-inline {
          margin-top: 25px;
          padding-top: 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .hours-title {
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 12px 0;
        }

        .hours-compact {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .hours-item-compact {
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
        }

        .hours-item-compact strong {
          color: #3880ff;
        }

        .block-title {
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 25px;
          position: relative;
          padding-bottom: 10px;
        }

        .block-title::after {
          content: "";
          position: absolute;
          width: 40px;
          height: 3px;
          background: #3880ff;
          bottom: 0;
          left: 0;
          border-radius: 2px;
        }

        .footer-nav {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-nav li {
          margin-bottom: 14px;
        }

        .footer-nav a {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          position: relative;
          transition: all 0.2s ease;
          font-size: 15px;
          padding-left: 0;
        }

        .footer-nav a::before {
          content: "›";
          opacity: 0;
          position: absolute;
          left: -12px;
          transition: all 0.2s ease;
        }

        .footer-nav a:hover,
        .footer-nav a.active {
          color: #3880ff;
          padding-left: 12px;
        }

        .footer-nav a:hover::before,
        .footer-nav a.active::before {
          opacity: 1;
        }

        .hours-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .hours-item {
          display: flex;
          justify-content: space-between;
          color: rgba(255, 255, 255, 0.7);
          font-size: 14px;
          padding-bottom: 12px;
          border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
        }

        .hours-item .day {
          font-weight: 500;
        }

        .hours-item .time {
          color: rgba(255, 255, 255, 0.9);
        }

        .contact-locations {
          background: rgba(255, 255, 255, 0.03);
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid rgba(255, 255, 255, 0.05);
        }

        .location-tab {
          display: flex;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        }

        .location-name {
          flex: 1;
          padding: 12px;
          text-align: center;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s ease;
          border-bottom: 3px solid transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .location-name.active {
          background: rgba(56, 128, 255, 0.1);
          border-bottom-color: #3880ff;
          color: #3880ff;
        }

        .location-details {
          padding: 20px 15px;
        }

        .contact-block .location-info {
          display: flex;
          flex-direction: column;
          gap: 18px;
          background: rgba(255, 255, 255, 0.02);
          padding: 20px;
          border-radius: 10px;
          border: 1px solid rgba(255, 255, 255, 0.05);
        }

        .info-item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          line-height: 1.5;
        }

        .info-icon {
          color: #3880ff;
          margin-top: 3px;
          width: 16px;
        }

        .footer-social {
          max-width: 1200px;
          margin: 40px auto 0;
          padding-top: 30px;
          border-top: 1px solid rgba(255, 255, 255, 0.05);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 20px;
        }

        .social-connect {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .social-connect h3 {
          font-size: 16px;
          font-weight: 600;
          margin: 0;
        }

        .social-icons {
          display: flex;
          gap: 15px;
        }

        .social-icons a {
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          color: rgba(255, 255, 255, 0.7);
          transition: all 0.3s ease;
        }

        .social-icons a.active,
        .social-icons a:hover {
          background: #3880ff;
          color: white;
          transform: translateY(-3px);
          box-shadow: 0 4px 10px rgba(56, 128, 255, 0.3);
        }

        .cta-button a {
          display: inline-block;
          padding: 12px 24px;
          background: linear-gradient(45deg, #3880ff, #38a5ff);
          color: white;
          text-decoration: none;
          border-radius: 4px;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .cta-button a:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(56, 128, 255, 0.3);
        }

        .copyright {
          background: rgba(0, 0, 0, 0.25);
          padding: 20px;
          position: relative;
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
        }

        .copyright-content {
          text-align: center;
          max-width: 1200px;
          margin: 0 auto;
        }

        .copyright-content p {
          margin: 0 0 10px 0;
        }

        .legal-links {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          opacity: 0.8;
        }

        .legal-links span {
          cursor: pointer;
          transition: color 0.2s ease;
        }

        .legal-links span:not(:nth-child(2n)):hover {
          color: #3880ff;
        }

        .scroll-top {
          position: absolute;
          right: 30px;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.1);
          color: white;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .scroll-top:hover {
          background: #3880ff;
          transform: translateY(-50%) scale(1.1);
        }

        @media (max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .nav-columns {
            flex-direction: column;
            gap: 20px;
          }

          .company-stats {
            grid-template-columns: repeat(3, 1fr);
            gap: 15px;
          }

          .stat-item {
            padding: 12px 5px;
          }

          .stat-number {
            font-size: 1.5rem;
          }

          .stat-label {
            font-size: 0.7rem;
          }

          .footer-social {
            flex-direction: column;
            align-items: flex-start;
            gap: 30px;
          }

          .copyright {
            padding: 40px 20px;
          }

          .legal-links {
            flex-wrap: wrap;
            gap: 5px;
          }

          .scroll-top {
            position: static;
            transform: none;
            margin: 20px auto 0;
          }
        }

        @media (max-width: 1024px) and (min-width: 769px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 35px;
          }

          .nav-columns {
            flex-direction: column;
            gap: 20px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
